var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","fill":"none"}},_vm.$listeners),[_c('path',{attrs:{"fill":"currentColor","d":"M16 0H2C.9 0 0 .9 0 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2m0 16H2v-4.58l.99.99 4-4 4 4 4-3.99L16 9.43zm0-9.41-1.01-1.01-4 4.01-4-4-4 4-.99-1V2h14z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }